import { PageTabContent } from '../../cohort-builder-page-layout/StyledPageTabContent/PageTabContent';
import { DerivedEventsSection } from '../../cohort-builder-sections/DerivedEventsSection/DerivedEventsSection';
import { SimpleEventSection } from '../../cohort-builder-sections/SimpleEventSection/SimpleEventSection';

export const EventsPageTabContent = () => {
  return (
    <PageTabContent>
      <SimpleEventSection />
      <DerivedEventsSection />
    </PageTabContent>
  );
};
